{
	"title": "Phase standings",
	"rule": {
		"NONE": "This phase has no table: each meet stands on its own.",
		"MEET_RANK": "Ranked by the place in the phase's meet.",
		"RESULT_BEST": "Ranked by each competitor's best result in the phase.",
		"RESULT_SUM": "Ranked by the total over every round.",
		"POINTS_SUM": "Ranked by points, then score difference, then score for.",
		"POINTS_SUM_BWF": "Ranked by points (BWF): level sides are separated by their own match, or by matches, games and points difference."
	},
	"counts": "Counts unofficial and official results.",
	"filter": {
		"pool": "Pool",
		"allPools": "All pools",
		"poolName": "Pool {{pool}}",
		"round": "Round",
		"allRounds": "All rounds",
		"roundName": "Round {{round}}",
		"apply": "Show table",
		"reset": "Reset",
		"label": "Standings filters"
	},
	"col": {
		"rank": "Rank",
		"competitor": "Competitor",
		"noc": "NOC",
		"best": "Best",
		"total": "Total",
		"result": "Result",
		"played": "Played",
		"won": "Won",
		"drawn": "Drawn",
		"lost": "Lost",
		"for": "For",
		"against": "Against",
		"diff": "Difference",
		"gamesDiff": "Games difference",
		"ralliesDiff": "Points difference (rallies)",
		"points": "Points",
		"mark": "Qualified",
		"tie": "Tie order"
	},
	"colShort": {
		"played": "P",
		"won": "W",
		"drawn": "D",
		"lost": "L",
		"for": "F",
		"against": "A",
		"diff": "+/−",
		"gamesDiff": "G+/−",
		"ralliesDiff": "P+/−",
		"points": "Pts"
	},
	"noPool": "No pool",
	"unranked": "Not ranked",
	"tied": "Tied",
	"tiedBroken": "Tie broken",
	"bwfRule": "Ties on points (BWF): two level — the winner of their match; three or more — matches, then games, then points difference, then their match if two are still level. Still level: the referee's draw (Tie order).",
	"cut": "Qualifying places: {{count}}",
	"empty": {
		"title": "No standings yet",
		"body": "The table fills as meets of this phase become unofficial or official.",
		"noTableTitle": "No table for this stage",
		"noTableBody": "Each meet in this stage stands on its own: the bracket shows who goes through."
	},
	"meets": {
		"title": "Meets in this phase",
		"startList": "Start list",
		"open": "Open meet {{meet}}"
	},
	"tie": {
		"title": "Tie order",
		"edit": "Set tie order",
		"editPool": "Set tie order: {{names}}",
		"hint": "These competitors are tied on the results. Put them in the order decided by the swim-off, countback or drawing of lots: first is ranked higher.",
		"up": "Move {{name}} up",
		"down": "Move {{name}} down",
		"save": "Save tie order",
		"clear": "Clear tie order",
		"saved": "Tie order saved",
		"cleared": "Tie order cleared"
	},
	"advance": {
		"button": "Advance",
		"title": "Advance to the next phase",
		"to": "Advance to",
		"hint": "Tick everyone who goes through. This list replaces any earlier advance from this phase: competitors no longer ticked are taken out of the next phase.",
		"preselected": "The top {{count}} by rank are ticked.",
		"rerun": "The competitors who already went through are ticked.",
		"markAll": "Mark everyone as",
		"mark": "Qualification for {{name}}",
		"seedByOrder": "Seed the next phase in this order",
		"selected_one": "{{count}} competitor goes through",
		"selected_other": "{{count}} competitors go through",
		"confirm": "Advance {{count}}",
		"noNextPhase": "This event has no later phase to advance to.",
		"filteredWarning": "The table above is filtered. Advancing always uses the whole phase, without live meets.",
		"resultTitle": "Advanced to {{phase}}",
		"entered": "Entered in {{phase}}",
		"dropped": "Taken out of {{phase}}",
		"marksCleared": "Qualification mark cleared",
		"rejected": "Not advanced: not an entered competitor of this event",
		"notDropped": "Still in {{phase}}: already on one of its start lists. Take them off that start list, then advance again.",
		"nothingChanged": "Nothing changed: this list was already applied.",
		"nextStep": "Put them on a start list:",
		"heatRule": {
			"title": "Tick by the heats rule",
			"byPlace": "First in each heat (Q)",
			"byPerformance": "Then the next best (q)",
			"apply": "Tick by this rule",
			"hint_one": "Places come from the heat's own ranking; the rest go on their result across the {{count}} heat. Ties at the last place all go through, so check the list before you advance.",
			"hint_other": "Places come from each heat's own ranking; the rest go on their result across the {{count}} heats. Ties at the last place all go through, so check the list before you advance."
		}
	},
	"fill": {
		"button": "Fill slots",
		"title": "Fill slots from this table",
		"hint": "Confirm the pool order first: break any tie with a tie order. Slots in meets that have started, or that hold a result, are never rewritten.",
		"pool": "Fill from",
		"allPools": "Every pool",
		"waiting_one": "{{count}} slot is waiting on this phase.",
		"waiting_other": "{{count}} slots are waiting on this phase.",
		"noneWaiting": "No slot is waiting on this phase. Filling again corrects slots that no longer match the table.",
		"slot": "{{meet}}, {{side}}",
		"slotNoSide": "{{meet}}",
		"willTake": "Will take",
		"tiedCandidate": "Tied: break the tie first",
		"noCandidate": "Nobody at this rank yet",
		"previewNote": "Preview from unofficial and official results, the same table the server uses.",
		"confirm": "Fill slots",
		"resultTitle": "Slots filled",
		"filled": "Filled",
		"notRefilled": "Not rewritten: the meet has started or the slot holds a result",
		"unresolved": "Left empty: no single competitor at that rank yet",
		"nothing": "No slot changed.",
		"duplicateFill": "Nothing was filled: two slots of one meet would take the same competitor. The bracket's sources are wired wrong; correct them, then fill again.",
		"filledItem": "{{slot}}: {{name}}"
	},
	"refusal": {
		"locked": "The medal desk has locked this event. Nothing beneath it can change until it is unlocked.",
		"entries": "Some competitors are not entered in this event. Reload the page.",
		"offline": "Not saved: the server could not be reached. Try again."
	},
	"phases": "Phases of this event",
	"tabs": {
		"label": "View",
		"standings": "Standings",
		"bracket": "Bracket",
		"brackets": "Brackets"
	},
	"window": {
		"stage": "Stage",
		"noTableTitle": "No standings for this event",
		"noTableBody": "Standings show for group and pool stages, heats and qualification. This event has none yet: see its bracket.",
		"fullPage": "Open the full standings page (advance, fill slots, tie order)"
	},
	"bracket": {
		"title": "Bracket",
		"subtitle": "Round by round. Click a match to open it.",
		"legend": "Legend",
		"legendThrough": "Went through",
		"legendWaiting": "Waiting",
		"gold": "Gold medal match",
		"bronze": "Bronze medal match",
		"others": "Other matches",
		"winner": "Winner",
		"bye": "Bye",
		"open": "To be decided",
		"noTime": "Time not set",
		"matches_one": "{{n}} match",
		"matches_other": "{{n}} matches",
		"emptyTitle": "No knock-out matches yet",
		"emptyBody": "The bracket fills in as the knock-out rounds get their matches.",
		"round": {
			"QUALIFICATION": "Qualification",
			"HEAT": "Heats",
			"GROUP": "Group",
			"ROUND": "Round",
			"R128": "Round of 128",
			"R64": "Round of 64",
			"R32": "Round of 32",
			"R16": "Round of 16",
			"QUARTERFINAL": "Quarter-finals",
			"SEMIFINAL": "Semi-finals",
			"REPECHAGE": "Repechage",
			"BRONZE": "Bronze medal match",
			"FINAL": "Final",
			"RANKING": "Placing matches",
			"TIEBREAK": "Tie-break"
		},
		"source": {
			"winnerOf": "Winner of {{meet}}",
			"loserOf": "Loser of {{meet}}",
			"rankOfMeet": "Rank {{rank}} in {{meet}}",
			"rankOfPool": "Rank {{rank}} in group {{pool}}",
			"rankOfPhase": "Rank {{rank}} in {{phase}}"
		}
	},
	"heatSummary": {
		"title": "Heat summary"
	},
	"groups": {
		"label": "Groups",
		"all": "All groups",
		"name": "Group {{pool}}",
		"table": "Table",
		"team": "Team",
		"qualified": "Qualified",
		"short": {
			"played": "P",
			"won": "W",
			"drawn": "D",
			"lost": "L",
			"diff": "GD",
			"gamesDiff": "G±",
			"ralliesDiff": "PD",
			"points": "PTS"
		},
		"noResults": "No results yet."
	}
}
